export const home_i18n = {
    text1: "أرسل أول تسجيل وصول للتوقيع",
    text2: "يجمع تسجيل الوصول الافتراضي البيانات الحيوية للنزيل ويربطها بحجزه.",
    text3: "إرسال تسجيل الوصول",
    text4: 'الرئيسية',
    text5: "تسجيل الوصول",
    text6: "مرحبًا بك",
    text7: "إعدادات تسجيل الوصول",
    text8: "حسابي",
    text9: "إعدادات تسجيل الوصول",
    text10: "تسجيل الخروج",
    text11: "صورة الفندق",
    text12: "سياسات الفندق",
    text13: "رسائل الترحيب",
    text14: "ارفع شعار فندقك",
    text15: "اختر الشعار أو اسحبه",
    text16: "إلغاء",
    text17: "اسم الفندق",
    text18: "حفظ التغييرات",
    text19: "تغيير الشعار",
    text20: "تنزيل",
    text21: "سجل التوقيعات",
    text22: "لوحة التحكم بالوثائق التي وقّعها النزلاء.",
    text23: "تصفية:",
    text24: "معطّل",
    text25: "حسب التاريخ",
    text26: "حسب الدولة",
    text27: "الاسم",
    text28: "اسم العائلة",
    text29: "الجنسية",
    text30: "تاريخ تسجيل الوصول",
    text31: "متزامن",
    text32: "الخيارات",
    text33: "لا توجد بيانات",
    text34: "الصفوف لكل صفحة:",
    text35: "بحث",
    text36: "الدول",
    text37: "من",
    text38: "إلى",
    text39: "COPYRIGHT © 2022 ، جميع الحقوق محفوظة WACheckines",
    text40: "صُنع بـ",
    text41: "تصدير",
    text42: "عرض التفاصيل",
    text43: "عرض PDF الموقَّع",
    text44: "حذف",
    text45: "اختر خيارًا",
    //aca
    text46: "إضافة وسيلة دفع",
    text47: "سجّل أو حدّث وسيلة الدفع التي ستُحصَّل بها الرسوم الشهرية.",
    text48: "إجمالي المستحقات",
    text49: "تم الدفع بنجاح",

    p1: "أنت في النسخة التجريبية",
    p2: "لديك",
    p3: "يومًا متبقيًا!",
    p4: "انتهت الفترة التجريبية.",
    p5: "اشترك الآن",
    p6: "انتهت فترتك التجريبية المجانية!",

};